import React from 'react';
import {riskTypeIdentifiers} from "../../../routes";
import {RiskRowBox} from "./RiskRowBox";
import {useQueryWithAccessToken} from "../../../hooks/TanstackHooks";
import {cacheKeys} from "../../../services/shared/serviceConstants";
import {getPanelLink} from "../DashboardPanels/panelCommon";
import {getZombiesCount} from "../../../services/shared/Zombies";
import {TotalPanel} from "../TotalPanel";

interface ZombieCountProps {
  numberInCircle: number;
}
export const ZombieCount = (props: ZombieCountProps) => {

  const {isLoading, data, isError} = useQueryWithAccessToken({
      queryKey: [cacheKeys.zombiesCount],
      queryFunction: getZombiesCount,
      queryFunctionVariables:{}
    }
  );


  return (<RiskRowBox>
    <TotalPanel
      totalCount={data}
      title="Zombie Users"
      description={<span><em>Users that have become active again in the last 28 days</em></span>}
      viewAllUrl={getPanelLink(riskTypeIdentifiers.zombies, data)}
      numberInCircle={props.numberInCircle}
      isLoading={isLoading}
      isError={isError}
    />
  </RiskRowBox>)
};
